import { useSelectionStore } from '@/store/selectionStore';
import styles from './SpatialCanvas.module.css';

/** Renders inside the world layer so it inherits the camera transform. */
export const MarqueeOverlay = () => {
  const marquee = useSelectionStore((s) => s.marquee);
  if (!marquee) return null;
  return (
    <div
      className={styles.marquee}
      style={{
        left: marquee.minX,
        top: marquee.minY,
        width: marquee.maxX - marquee.minX,
        height: marquee.maxY - marquee.minY,
      }}
    />
  );
};
